import NoteRequirementCard from "./NoteRequirementCard";

export default NoteRequirementCard;
